import { object, string } from "zod";

export const testNetSuiteReturnAuthorization = {
  name: "testNetSuiteReturnAuthorization" as const,
  input: object({ returnId: string().min(1, "Return ID is required") }),
  output: object({ result: string() }),
};
